import LayoutNavbar from './Layout/Navbar.vue';
import TeamMember from './Team/Member.vue';

export default {
    LayoutNavbar,
    TeamMember,
}
